<template>
  <div class="coins-recharge">

    <div class="pay-title-div">
      <div class="pay-title-left">
        <div class="title-left-hd">
          <van-icon :name="yaogongbi"/>
          剩余邀工币 <span>{{ coinRemain }}</span>
        </div>

        <div class="title-left-ft" v-if="coinNeed">
          还需再充值至少<span>{{ coinNeed }}</span>个邀工币
        </div>
      </div>

      <div class="pay-title-right">
        <img class="recharge-img" :src="coinBi">
      </div>
      <img class="mingxi" :src="mingxi" @click="toMingXi">
    </div>

    <div class="recharge-hd">
      <div class="swipe-div" v-if="bannerShow">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(banner, index) in banners" :key="index">
            <img v-lazy="banner.imgUrl" class="bannerImg" @click="onBanner(banner)"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="pay-title">
        请选择充值金额
      </div>
    </div>

    <div class="recharge-bd">

      <template>
        <van-row gutter="10">
          <van-col span="8" v-for="(item, index) in payList" :key="index">
            <div :class="active === index ? 'active' : ''" class="div-col"
                 @click="clickCoins(index)">
              <div class="discount-div" style="position: relative;">
                <img class="shouchong" :src="chongzhi_tag_shouchong" v-if="item.activityJoinFlag === 1"/>
                <!--                <img class="shouchong" :src="chongzhi_tag_shouchong"/>-->
                <div v-if="item.discount < 10" class="discount">{{ item.discount }}折</div>
              </div>
              <div class="coins-num">
                <span class="money">{{ item.coinNum }}</span>
                <span class="coins">币</span>
              </div>
              <div class="recharge-price">
                售价 <span>{{ item.price }}元</span>
              </div>
            </div>
          </van-col>
        </van-row>
      </template>
    </div>

    <div class="pay-info">
      <div class="title">选择支付方式</div>

      <div class="pay-content">
        <van-radio-group v-model="checked" class="pay-radio-group">
          <van-cell-group inset :border="false">
            <van-cell :border="false" clickable @click="checked = '1'">
              <template #title>
                <van-icon :name="wechatImg" class="img"/>
                <span class="custom-title">微信支付</span>
              </template>
              <template #right-icon>
                <van-radio name="1"/>
              </template>
            </van-cell>

            <van-cell :border="false" clickable @click="checked = '2'">
              <template #title>
                <van-icon :name="alipayImg" class="img"/>
                <span class="custom-title">支付宝</span>
              </template>
              <template #right-icon>
                <van-radio name="2"/>
              </template>
            </van-cell>

          </van-cell-group>
        </van-radio-group>
        <div class="pay-agreement">支付即代表同意<a @click="toRechargeProtocol"> 《用户充值协议》</a></div>
      </div>
    </div>

    <div class="pay-info">
      <div class="title">充值邀工币可以</div>

      <div class="pay-content pay-other">
        <van-row gutter="10">
          <van-col span="12">
            <van-radio-group class="pay-radio-group">
              <van-cell-group inset>
                <van-cell clickable>
                  <template #title>
                    <van-icon :name="chongzhi_icon_1" class="img"/>
                    <span class="custom-title">拨打招工电话</span>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-col>
          <van-col span="12">
            <van-radio-group class="pay-radio-group">
              <van-cell-group inset>
                <van-cell clickable>
                  <template #title>
                    <van-icon :name="chongzhi_icon_2" class="img"/>
                    <span class="custom-title">拨打找活电话</span>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-col>
          <van-col span="12">
            <van-radio-group class="pay-radio-group">
              <van-cell-group inset>
                <van-cell clickable>
                  <template #title>
                    <van-icon :name="chongzhi_icon_3" class="img"/>
                    <span class="custom-title">置顶招工信息</span>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-col>
          <van-col span="12">
            <van-radio-group class="pay-radio-group">
              <van-cell-group inset>
                <van-cell clickable>
                  <template #title>
                    <van-icon :name="chongzhi_icon_4" class="img"/>
                    <span class="custom-title">置顶找活广告</span>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="bottom-btn">
      <div class="bottom-price">
        充值金额：<a>￥{{ payList[active].price }}</a>
      </div>
      <van-button round size="normal" color="#096CEFFF" @click.stop="recharge" block>立即支付
      </van-button>
    </div>

    <van-popup v-model:show="show" :style="{ width: '80%',padding:'10px' }">

      <img :src="bgi">

      <div class="login_content">
        <div class="login_div">
          <van-cell-group inset>
            <van-field type='number' left-icon="orders-o" placeholder="请输入手机号" v-model="phone">
              <template #left-icon>
                <van-icon name="orders-o" color="#1989fa"/>
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div class="login_div">
          <van-field type='number' left-icon="envelop-o" placeholder="请输入验证码" v-model="code">
            <template #left-icon>
              <van-icon name="envelop-o" color="#1989fa"/>
            </template>
            <template #button>

              <van-button v-if="count==60" class="get-code-btn" round color="#096CEFFF" size="mini"
                          @click.stop="sendLoginCode">获取验证码
              </van-button>

              <template v-else>
                <a class="p-r-10">|</a>
                <a class="get-code">{{ count }}</a>
              </template>
            </template>
          </van-field>
        </div>

        <div class="login-btn-div" style="text-align: center">
          <van-button @click="login" round color="#096CEFFF" style="width: 60%">登录</van-button>
        </div>
      </div>

    </van-popup>

  </div>

</template>


<script>
import { coinPrice, getNo, getBanner } from '@api/coins'
import { login, sendLoginCode } from '@api/home'

import chongzhi_tag_shouchong from '../../assets/images/coins/pay/chongzhi_tag_shouchong@2x.png'

import chongzhi_icon_1 from '../../assets/images/coins/pay/chongzhi_icon_1@2x.png'
import chongzhi_icon_2 from '../../assets/images/coins/pay/chongzhi_icon_2@2x.png'
import chongzhi_icon_3 from '../../assets/images/coins/pay/chongzhi_icon_3@2x.png'
import chongzhi_icon_4 from '../../assets/images/coins/pay/chongzhi_icon_4@2x.png'

import mingxi from '../../assets/images/coins/pay/chongzhi_btn_mingxi@2x.png'
import chongzhiBanner from '../../assets/images/coins/pay/chongzhi_banner@2x.png'
import coinBi from '../../assets/images/coins/pay/coin-bi.png'
import coinBiBg from '../../assets/images/coins/pay/coin-bi-bg.png'
import yaogongbi from '../../assets/images/coins/pay/chongzhi_icon_yaogongbi@2x.png'
import alipayImg from '../../assets/images/coins/pay_icon_alipay.png'
import wechatImg from '../../assets/images/coins/pay_icon_wechat.png'
import bgi from '../../assets/images/coins/login-bgi.png'

export default {
  name: 'coins-recharge',
  components: {},
  data () {
    return {
      coinRemain: undefined,
      coinNeed: undefined,

      bannerShow: false,
      chongzhi_tag_shouchong: chongzhi_tag_shouchong,
      chongzhi_icon_1: chongzhi_icon_1,
      chongzhi_icon_2: chongzhi_icon_2,
      chongzhi_icon_3: chongzhi_icon_3,
      chongzhi_icon_4: chongzhi_icon_4,
      mingxi: mingxi,
      banners: [],
      yaogongbi: yaogongbi,
      coinBi: coinBi,
      coinBiBg: coinBiBg,
      chongzhiBanner: chongzhiBanner,
      alipayImg: alipayImg,
      wechatImg: wechatImg,
      active: 0,
      evaluateTitleList: [
        { name: '1', title: '充值记录' },
        { name: '2', title: '使用记录' }
      ],
      checked: '1',
      payList: [{ coinNum: 0, price: 0 }],

      // 登录相关参数
      show: false,
      bgi: bgi,
      phone: undefined,
      code: undefined,
      count: 60,
    }
  },

  created () {

    let coinNeed = this.$route.query.coinNeed

    if (coinNeed && coinNeed !== 'undefined') {
      this.coinNeed = coinNeed
    }

    // 获取banner
    this.getBanner()

    // 获取充值数据
    this.getCoinPrice()

    // 通过ua标识判断
    let userAgent = navigator.userAgent.toLowerCase()//获取UA信息
    //判断ua中是否含有和app端约定好的标识yaogong
    if (userAgent.indexOf('yaogong') === -1) {
      this.noApp = true
    }
  },

  methods: {

    // 跳转邀工币明细
    toMingXi () {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/coinsHist?fromPay=pay`,
        title: '邀工币'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // banner点击
    onBanner (e) {
      if (e.jumpType == 1) {
        // this.enterRouter('trainingLearning', { typeId: e.jumpUrl })
        const data = {
          url: `${process.env.VUE_APP_BASE_HOST}/` + e.jumpUrl,
          title: e.typeName
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      }
      // else {
      //   const data = {
      //     url: e.jumpUrl,
      //     title: e.typeName
      //   }
      //   this.$bridge.callHandler('newPage', data, response => {
      //     console.log('response:', response)
      //   })
      // }
    },

    // 获取登录验证码
    sendLoginCode () {
      sendLoginCode({
        phone: this.phone
      }).then(res => {
        if (res.data.code === 200) {

          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.timer = setInterval(() => {
              if (this.count > 1 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                clearInterval(this.timer)
                this.timer = null
                this.count = 60
              }
            }, 1000)
          }

        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 登录
    login () {
      login({
        phone: this.phone,
        checkCode: this.code
      }).then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('token', res.data.data.token)
          sessionStorage.setItem('companyId', '0')
          this.show = false
          this.$toastMsg('登录成功')
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    getBanner () {
      getBanner().then(res => {
        if (res.data.code === 200) {
          this.banners = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取邀工币数量
    getNo () {
      getNo().then(res => {
        if (res.data.code === 200) {
          this.coinRemain = res.data.data.coin

          // 如果是补充，计算所需邀工币，默认选中需要最少充值的邀工币
          if (this.coinNeed) {
            let coinCount = parseInt(this.coinNeed)// + parseInt(this.coinRemain)
            for (let i = 0; i < this.payList.length; i++) {
              if (this.payList[i].coinNum >= coinCount) {
                this.active = i
                console.log('this.active', this.active)
                return
              }
            }
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取充值数据
    getCoinPrice () {
      coinPrice().then(res => {
        if (res.data.code === 200) {
          this.payList = res.data.data

          if (this.payList[0].activityJoinFlag == 1) {
            this.bannerShow = true
          }

          this.getNo()

        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 跳转充值协议
    toRechargeProtocol () {
      const data = {
        title: '充值协议',
        url: `${process.env.VUE_APP_BASE_HOST}/staticPages/recharge`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 充值
    recharge () {
      let priceId = this.payList[this.active].id
      if (this.noApp) {
        if (!sessionStorage.getItem('token')) {
          this.show = true
          this.$toastMsg('请先登录')
          return
        }
        // this.enterRouter('coinsRecharge', { priceId: priceId, payType: this.checked })
      } else {
        // if (this.coinNeed && this.coinNeed !== 'undefined') {
        //   const data = {
        //     title: '支付',
        //     url: `${process.env.VUE_APP_BASE_HOST}/coinsRecharge?payType=` + this.checked + '&coinNum=' + this.coinNeed
        //   }
        //   this.$bridge.callHandler('newPage', data, response => {
        //     console.log('response:', response)
        //   })
        // } else {
        if (priceId) {
          const data = {
            title: '支付',
            url: `${process.env.VUE_APP_BASE_HOST}/coinsRecharge?priceId=` + priceId + '&payType=' + this.checked + '&coinNum=' + this.coinNeed
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        } else {
          this.$toastMsg('请选择充值数量')
        }
        // }
      }
    },

    // 选择充值数
    clickCoins (index) {
      this.active = index
    },
  }
}
</script>

<style scoped lang="scss">

.coins-recharge {
  padding-bottom: calc(60px + env(safe-area-inset-bottom));

  .pay-title {
    font-size: 16px;
    font-weight: bold;
  }

  .f30 {
    font-size: 35px;
    line-height: 25px;
  }

  .p-r-3 {
    padding-right: 3px;
  }

  [class*=van-hairline]::after {
    border: 0 solid #F7F8FAFF;
  }

  .pay-title-div {
    background-color: #096CEFFF;
    display: flex;
    color: #FFFFFFFF;
    padding: 10px 0;

    .pay-title-left {
      width: 100%;
      margin: auto;
      padding-left: 20px;

      .title-left-hd {
        font-size: 16px;
        //display: -webkit-inline-box;

        .van-icon {
          font-size: 20px;
          vertical-align: -15%;
        }

        span {
          font-size: 28px
        }
      }

      .title-left-ft {
        font-size: 14px;
        color: #9abff1;

        span {
          font-size: 20px
        }
      }
    }

    .pay-title-right {
      background-size: cover;
      width: 160px;
      height: 70px;
      margin-top: 16px;
      background-image: url('../../assets/images/coins/pay/coin-bi-bg.png');

      .recharge-img {
        height: 80px;
        width: 95px;
        margin: -10px 15px 0 30px;
      }
    }

    .mingxi {
      top: 30px;
      right: 0;
      width: 55px;
      height: 23px;
      position: absolute;
    }

  }

  .recharge-hd {
    background-color: #FFFFFF;
    padding: 10px 10px 0 10px;
    z-index: 9;
    margin-top: -10px;
    border-radius: 10px 10px 0 0;

    .swipe-div {
      margin-bottom: 12px;
    }

    .num {
      font-size: 18px;
      font-weight: bold;
    }

    .info {
      padding-top: 10px;
      font-size: 14px;
      color: #999999;
    }
  }

  .recharge-bd {
    background-color: #FFFFFF;
    padding: 0 10px 10px 10px;

    .div-col {
      font-size: 18px;
      font-weight: bold;
      color: #096CEFFF;
      text-align: center;
      border-radius: 8px;
      margin-top: 10px;
      height: 90px;
      background-color: #F7F8FAFF;

      .coins-num {
        padding-top: 5px;
      }

      .recharge-price {
        color: #333333FF;
        font-size: 14px;
        font-weight: 400;
        padding-top: 6px;
      }

      .money {
        padding-top: 5px;
        padding-right: 3px;
      }
    }

    .active {
      color: white;
      background-color: #81CDFFFF;

      .recharge-price {
        color: #F7F8FAFF;
      }
    }

    .discount-div {
      width: 100%;
      height: 18px;
    }

    .shouchong {
      width: 90px;
      height: 20px;
      position: absolute;
      top: -5px;
    }

    .discount {
      float: right;
      padding: 1px 0;
      font-weight: 400;
      font-size: 12px;
      width: 50%;
      border-radius: 0 5px 0 5px;
      background-color: #FFB111FF;
      color: white;
    }

  }

  .pay-info {
    background-color: #FFFFFF;
    padding: 10px;
    margin-top: 10px;

    .title {
      margin-top: 2px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
    }

    .pay-content {
      border-radius: 5px;
      //background-color: #F7F8FAFF;

      .pay-radio-group {

        .img {
          font-size: 35px;
          vertical-align: -32%
        }

        .custom-title {
          font-size: 16px;
          padding-left: 10px;
          line-height: 40px;
        }

        .van-cell-group--inset {
          margin: 0;
        }

        .van-cell-group {

          .van-cell {
            border-radius: 7px;
            padding: 10px;
            margin-bottom: 10px;
            background-color: #F7F8FAFF;
          }
        }
      }

      .pay-agreement {
        font-size: 12px;
      }
    }
  }

  .pay-other {
    .pay-radio-group {
      .img {
        font-size: 26px !important;
        vertical-align: -24% !important;
      }

      .custom-title {
        padding-left: 6px;
      }
    }
  }

  .van-cell {
    display: flex;

    //.van-cell__label {
    //  font-size: 14px !important;
    //}
    //
    //.van-cell__value {
    //  flex-grow: 0.3;
    //  text-align: right;
    //}
  }

  //cell相关
  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-cell {
    display: flex;
    padding-left: revert;
    padding-right: revert;
    color: #333;
    line-height: 35px;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-cell:not(:last-child)::after {
    display: inline;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-field__control {
    font-size: 16px;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-cell__value {
    text-align: left;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-field__label {
    width: 100%;
    font-weight: normal;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-field__left-icon {
    display: inline !important;
  }

  //.van-button--plain.van-button--primary {
  //  color: #096CEFFF;
  //}
  //
  //.van-button--primary {
  //  color: #fff;
  //  border: 0.02667rem solid #096CEFFF;
  //}

  .login_content {

    //noinspection CssInvalidPseudoSelector
    ::v-deep .van-cell {
      border: 1px solid #CCCCCCFF;
      border-radius: 25px;
      background-color: #F2F2F2FF;
      padding: 5px 10px;
      width: 90%;
      margin-left: 5%;
      height: 40px;
      line-height: 30px;
    }

    .van-field__left-icon {
      padding-top: 2px;
    }

    .login_div {
      padding-top: 15px;
    }


    .get-code-btn {
      bottom: 8px;
      height: 25px;
      padding: 10px;
    }

    .p-r-10 {
      padding-right: 10px;
    }

    .count-num {
      font-size: 18px;
      padding-right: 10px;
    }

  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-field__button {
    height: 30px;
  }

  .login-btn-div {
    padding-top: 20px;
    padding-bottom: 20px;

    //.van-button {
    //  height: 30px;
    //}
  }

  .bottom-btn {
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.05);
    padding-bottom: env(safe-area-inset-bottom);
    bottom: 0;
    background-color: #FFFFFF;

    .bottom-price {
      font-size: 14px;
      padding-left: 10px;
      width: 100%;
      margin: auto;
      text-align: left;

      a {
        font-weight: bold;
        font-size: 18px;
      }
    }

    .van-button {
      width: 60%;
      font-size: 15px;
      margin: 6px 10px;
      height: 35px;
    }
  }
}


</style>
